export interface IOrderMessage {
  id: string;
  content: string;
  displayName: string;
  origin: string;
  createdAt: Date;
}
